var map = {
	"./vendor/spriteVideos/ENG_NarratorVideo/index.js": 6147,
	"./vendor/spriteVideos/ENG_SPS1-Basketball/index.js": 6148,
	"./vendor/spriteVideos/ENG_SPS10-Recess/index.js": 6149,
	"./vendor/spriteVideos/ENG_SPS2-FavoriteToy/index.js": 6150,
	"./vendor/spriteVideos/ENG_SPS3-NewFriends/index.js": 6151,
	"./vendor/spriteVideos/ENG_SPS4-Pants/index.js": 6152,
	"./vendor/spriteVideos/ENG_SPS5-FreeTime/index.js": 6153,
	"./vendor/spriteVideos/ENG_SPS6-HitByBalll/index.js": 6154,
	"./vendor/spriteVideos/ENG_SPS7-SpiltJuice/index.js": 6155,
	"./vendor/spriteVideos/ENG_SPS8-AfterSchool/index.js": 6156,
	"./vendor/spriteVideos/ENG_SPS9-ArtSupplies/index.js": 6157,
	"./vendor/spriteVideos/ENG_SPT1-Puppy_225002807/index.js": 6158,
	"./vendor/spriteVideos/ENG_SPT10-Soccer_225003020/index.js": 6159,
	"./vendor/spriteVideos/ENG_SPT11-Pool_225002889/index.js": 6160,
	"./vendor/spriteVideos/ENG_SPT12-ToyBox_225003055/index.js": 6161,
	"./vendor/spriteVideos/ENG_SPT2-Kites_225002840/index.js": 6162,
	"./vendor/spriteVideos/ENG_SPT3-Window_225003111/index.js": 6163,
	"./vendor/spriteVideos/ENG_SPT4-Trees_225002956/index.js": 6164,
	"./vendor/spriteVideos/ENG_SPT5-Birthday_225002526/index.js": 6165,
	"./vendor/spriteVideos/ENG_SPT6-Chores_225002643/index.js": 6166,
	"./vendor/spriteVideos/ENG_SPT7-Cookie_225002682/index.js": 6167,
	"./vendor/spriteVideos/ENG_SPT8-Doctor_225002747/index.js": 6168,
	"./vendor/spriteVideos/ENG_SPT9-Book_225002585/index.js": 6169,
	"./vendor/spriteVideos/EN_SPT10-Candy/index.js": 6170,
	"./vendor/spriteVideos/EN_SPT11-Book-Birthday/index.js": 6171,
	"./vendor/spriteVideos/EN_SPT12-Candy-Jar/index.js": 6172,
	"./vendor/spriteVideos/EN_SPT13-Game/index.js": 6173,
	"./vendor/spriteVideos/EN_SPT14-Homework/index.js": 6174,
	"./vendor/spriteVideos/EN_SPT15-Playground/index.js": 6175,
	"./vendor/spriteVideos/EN_SPT16-Costume-Box/index.js": 6176,
	"./vendor/spriteVideos/EN_SPT9-Broken-Window-Boy/index.js": 6177,
	"./vendor/spriteVideos/EN_TOM-Toybox/index.js": 6178,
	"./vendor/spriteVideos/ES_SPT10-Candy/index.js": 6179,
	"./vendor/spriteVideos/ES_SPT11-Book-Birthday/index.js": 6180,
	"./vendor/spriteVideos/ES_SPT12-Candy-Jar/index.js": 6181,
	"./vendor/spriteVideos/ES_SPT13-Game/index.js": 6182,
	"./vendor/spriteVideos/ES_SPT14-Homework/index.js": 6183,
	"./vendor/spriteVideos/ES_SPT15-Playground/index.js": 6184,
	"./vendor/spriteVideos/ES_SPT16-Costume-Box/index.js": 6185,
	"./vendor/spriteVideos/ES_SPT9-Broken-Window-Boy/index.js": 6186,
	"./vendor/spriteVideos/ES_TOM-Toybox/index.js": 6187,
	"./vendor/spriteVideos/SP_NarratorVideo/index.js": 6188,
	"./vendor/spriteVideos/SP_SPS1-Basketball/index.js": 6189,
	"./vendor/spriteVideos/SP_SPS10-Recess/index.js": 6190,
	"./vendor/spriteVideos/SP_SPS2-FavoriteToy/index.js": 6191,
	"./vendor/spriteVideos/SP_SPS3-NewFriends/index.js": 6192,
	"./vendor/spriteVideos/SP_SPS4-Pants/index.js": 6193,
	"./vendor/spriteVideos/SP_SPS5-Freetime/index.js": 6194,
	"./vendor/spriteVideos/SP_SPS6-HitByBall/index.js": 6195,
	"./vendor/spriteVideos/SP_SPS7-SpiltJuice/index.js": 6196,
	"./vendor/spriteVideos/SP_SPS8-AfterSchool/index.js": 6197,
	"./vendor/spriteVideos/SP_SPS9-ArtSupplies/index.js": 6198,
	"./vendor/spriteVideos/SP_SPT1-Puppy/index.js": 6199,
	"./vendor/spriteVideos/SP_SPT10-Soccer/index.js": 6200,
	"./vendor/spriteVideos/SP_SPT11-Pool/index.js": 6201,
	"./vendor/spriteVideos/SP_SPT12-ToyBox/index.js": 6202,
	"./vendor/spriteVideos/SP_SPT2-Kites/index.js": 6203,
	"./vendor/spriteVideos/SP_SPT3-Window/index.js": 6204,
	"./vendor/spriteVideos/SP_SPT4-Trees/index.js": 6205,
	"./vendor/spriteVideos/SP_SPT5-Birthday/index.js": 6206,
	"./vendor/spriteVideos/SP_SPT6-Chorese/index.js": 6207,
	"./vendor/spriteVideos/SP_SPT7-Cookie/index.js": 6208,
	"./vendor/spriteVideos/SP_SPT8-Doctor/index.js": 6209,
	"./vendor/spriteVideos/SP_SPT9-Book/index.js": 6210,
	"./vendor/spriteVideos/TEST_EN_spt_bookbirthday/index.js": 6211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4337;